import { AutogenModelCallinStatusLookup, AutogenRowCallinStatusLookup } from "./autogen/AutogenModelCallinStatusLookup";

export class ModelCallinStatusLookup extends AutogenModelCallinStatusLookup<RowCallinStatusLookup> {
	constructor() {
		super(RowCallinStatusLookup);
	}
}

export class RowCallinStatusLookup extends AutogenRowCallinStatusLookup {
}